<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "SelectMarkets" });
import { SelectMultiple } from "../../../../selects/index.js";
import { MARKETS } from "../../config/market-codes.js";
import { t } from "svelte-i18n";
export let keys;
export let isDisabled = false;
export let minItems = 0;
export let maxItems = 1e3;
export let label = "resource.market.plural.label";
export let placeholder = "resource.market.plural.placeholder";
export let whitelist = [];
export let blacklist = [];
const EMBARGO = ["RUS", "PRK", "BLR"].concat(blacklist);
const format = (market) => ({
    key: market.key,
    label: $t(`global.${market.type}.${market.key}`),
    parentKey: market.parentKey
});
</script>

{#if MARKETS.length > 0 }

    <SelectMultiple
        bind:keys = { keys }
        blacklist = { EMBARGO }
        name = 'market.keys'
        options = { MARKETS.map(format) }
        { label }
        { placeholder }
        { isDisabled }
        { minItems }
        { maxItems }
        { whitelist }
    />

{/if}